module.exports = __webpack_public_path__ + "img/Delete.41a681fe.svg";